import { html } from 'htm/preact';
import { TextFieldEntry, isTextFieldEntryEdited, TextAreaEntry, isTextAreaEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from 'bpmn-js-properties-panel';
import { langs } from '@utils/helpers';

function MultilangProps(element) {

  let fields = [];
  Object.keys(langs).forEach(langCode => {
    fields.push({
      id: `name-${langCode}`,
      langCode,
      element,
      component: NameField,
      isEdited: isTextFieldEntryEdited
    });
    fields.push({
      id: `documentation-${langCode}`,
      langCode,
      element,
      component: DocumentationField,
      isEdited: isTextAreaEntryEdited
    });
  });
  return fields;
}

function NameField({ element, id, langCode }) {

  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  const langLabel = translate(langs[langCode]);

  const getValue = () => {
    return element.businessObject['name-' + langCode] || '';
  };

  const setValue = (value) => {
    let result = {};
    result['name-' + langCode] = value;
    return modeling.updateProperties(element, result);
  };

  return html`<${TextFieldEntry}
    id=${id}
    element=${element}
    label=${translate('Name') + ' (' + langLabel + ')'}
    getValue=${getValue}
    setValue=${setValue}
    debounce=${debounce}
  />`;
  // description=${ translate('Description text') }
  // tooltip=${ translate('Tooltip text') }
}

function DocumentationField({ element, id, langCode }) {

  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  const langLabel = translate(langs[langCode]);

  const getValue = () => {
    return element.businessObject['documentation-' + langCode] || '';
  };

  const setValue = (value) => {
    let result = {};
    result['documentation-' + langCode] = value;
    return modeling.updateProperties(element, result);
  };

  return html`<${TextAreaEntry}
    id=${id}
    element=${element}
    label=${translate('Documentation') + ' (' + langLabel + ')'}
    getValue=${getValue}
    setValue=${setValue}
    debounce=${debounce}
  />`;
  // description=${ translate('Description text') }
  // tooltip=${ translate('Tooltip text') }
}

export default MultilangProps;